"use client";

import { Button } from "@/components/actions/Button";
import If from "@/components/common/If";
import { DEFENDR_CATEGORY_NAV_ITEMS } from "@/features/defendr/page-data";
import { useNav } from "@/providers/Nav";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function Nav({ handle = "" }: { handle?: string }) {
  const pathname = usePathname();
  const { navRetracted } = useNav();
  return (
    <nav
      className={`sticky transition-all duration-300 ease-in-out ${navRetracted ? "top-0" : "top-[80px]"} z-[15000] bg-white py-6`}
    >
      <div className="contianer mx-auto flex justify-start md:justify-center gap-8 items-center overflow-auto px-gutter">
        {handle === "aspiro-defendr-door-system" ? (
          <div className="flex w-full flex-wrap items-center justify-center gap-3 text-sm font-semibold uppercase tracking-[0.2em] text-[#3f3a32] md:text-[0.8rem]">
            {DEFENDR_CATEGORY_NAV_ITEMS.map((item, index) => (
              <span key={item.href} className="contents">
                <Link href={item.href} className="transition-colors hover:text-gold">
                  {item.label}
                </Link>
                {index < DEFENDR_CATEGORY_NAV_ITEMS.length - 1 ? (
                  <span className="text-[#b7974a]">|</span>
                ) : null}
              </span>
            ))}
          </div>
        ) : (
          <>
            <div className="relative inline-block w-max">
              <select
                className="block appearance-none h-[48px] w-max max-w-[200px] bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 leading-tight focus:outline-none focus:shadow-outline"
                onChange={(e) =>
                  e.target.value && (window.location.href = e.target.value)
                }
              >
                <option value="">Available Categories</option>
                <option value="/categories/flush-wood-veneer">
                  Flush Wood Veneer
                </option>
                <optgroup label="" className="font-bold">
                  <option value="/products/select-wood-veneer">
                    Select Wood Veneer
                  </option>
                  <option value="/products/standard-wood-veneer">
                    Standard Wood Veneer
                  </option>
                </optgroup>
                <option value="/categories/flush-paintable">Flush Paintable</option>
                <optgroup label="" className="font-bold">
                  <option value="/products/premium-painted">
                    Premium Paintable
                  </option>
                  <option value="/products/standard-paintable">
                    Standard Paintable
                  </option>
                </optgroup>
                <option value="/categories/flush-laminates">Flush Laminates</option>
                <optgroup label="" className="font-bold">
                  <option value="/products/choice-laminates">
                    Choice Laminates
                  </option>
                  <option value="/products/everyday-laminates-hpdl">
                    Everyday Laminates
                  </option>
                </optgroup>
                <option value="/products/stile-and-rail">
                  Stile {"&"}" Rail
                </option>
                <option value="/products/aspiro-defendr-door-system">
                  Aspiro Series Defendr™ Door System
                </option>
              </select>
            </div>
            <Button
              href="/technical-resources"
              variant="secondary"
              isLight
              size="small"
            >
              Resources
            </Button>
            <Button href="/samples" variant="secondary" isLight size="small">
              Order Samples
            </Button>
            <Button href="/contact-us" variant="secondary" isLight size="small">
              Contact Us
            </Button>
          </>
        )}
      </div>
    </nav>
  );
}
